require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/directives/jv.FormTemplate.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/directives/jv.root-modal.directive.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');
require('../../../assets/lib/angular/angular-ui.js');
require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/jv.Facebook.js');
require('../../../assets/scripts/common/directives/jv.LoadingButton.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/common/directives/jv.iframe-preview.directive.js');
require('../../../assets/scripts/common/jv.TextUtil.js');
require('../../../assets/scripts/common/jv.EmployeeSelect.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.js');
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignModal.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/scripts/source/campaigns/V2/JV.Campaigns.select2services.js');
require('../../../assets/lib/js/angularmodule/angdirective.js');
require('../../../assets/lib/ngStorage/ngStorage.min.js');
require('../../../assets/scripts/common/directives/jv.HideOnBlur.js');
require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/lib/jquery/timepicker/jquery.timepicker.js');
require('../../../assets/scripts/common/directives/jv.Timepicker.js');
require('../../../assets/lib/js/angularmodule/JV.FB.Service.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/scripts/source/jv.source.modal-adapter.service.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignService.js');
require('../../../assets/scripts/source/campaigns/V2/JV.AddCampaign.js');
require('../../../assets/scripts/source/campaigns/V2/JV.EmailTemplate.js');
require('../../../assets/scripts/source/campaigns/V2/JV.SocialMessagesTemplate.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignConstants.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignDetails.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignContactList.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.svc.js');
require('../../../assets/lib/js/es5-shim.min.js');
require('../../../assets/lib/angularJS-NES/angular-sanitize.min.js');